import { Modal } from 'bootstrap'
import { trace } from 'rytm-helpers'
import { store } from './../store'
import { dcLoadStart, dcLoadAbord, dcLoadComplete, dcLoadError, dcCancel } from './../actions/actions_ajax'
import { viewAppend, viewRemove } from './../actions/actions_router'
import { startContainerPlayback, stopContainerPlayback } from './tsaw_mixer'
import { updateVnmaps } from '../../shared/vnmap'

export const AJAX_STATUS_LOADING = "loading"
export const AJAX_STATUS_ABORD = "abord"
export const AJAX_STATUS_COMPLETE = "complete"
export const AJAX_STATUS_ERROR = "error"
export const AJAX_STATUS_CANCEL = "cancel"
const CLASS_NAME_LOADING = "loading"
const CLASS_NAME_READY = "ready"
const ID_MODAL_HOTPOINT = "modalHotpoint"
let currentState

/**
 * ############
 * ### INIT ###
 */
 export const initTsawAjax = () => {
  //  offcanvas
  document.addEventListener("show.bs.offcanvas", onDocOffcanvasShow)
  document.addEventListener("hide.bs.offcanvas", onDocOffcanvasHide)
  document.addEventListener("hidden.bs.offcanvas", onDocOffcanvasHidden)
  // modals
  document.addEventListener("show.bs.modal", onDocModalShow)
  document.addEventListener("hidden.bs.modal", onDocModalHidden)
  // document click (hotpoint modal trigger)
  document.addEventListener("click", onDocClick, false)

  // no preloading on hover (to prevent sound playback)
  // document.addEventListener("mouseover", onDocMouseover, false)
  currentState = store.getState()
  store.subscribe(onStoreChange)
}

// check and load content for the dcWrapper
const handleDcLoad = (dcWrapper) => {
  if (dcWrapper.classList.contains(CLASS_NAME_LOADING)) {
    trace("skip loading...", dcWrapper)
    return false
  }
  if (dcWrapper.classList.contains(CLASS_NAME_READY)) {
    // wrapper already loaded... dispatch router event
    viewAppend(dcWrapper.dataset.dcUrl, dcWrapper)
    return false
  }
  handleDcRequest(dcWrapper)
}
// loadContent into dcWrapper
const handleDcRequest = (dcWrapper) => {
  // get the url
  const url = dcWrapper.dataset.dcUrl
  if (!url) {
    console.warn("skip handleDcRequest, missing URL!")
  }
  // ajax request
  let xhr = new XMLHttpRequest()
  xhr.dcWrapper = dcWrapper
  // add event listeners
  xhr.addEventListener('loadstart', onXhrLoadStart);
  xhr.addEventListener('load', onXhrLoad);
  xhr.addEventListener('loadend', onXhrLoadEnd);
  xhr.addEventListener('progress', onXhrProgress);
  xhr.addEventListener('error', onXhrError);
  xhr.addEventListener('abort', onXhrAbord);
  xhr.open('GET', url)
  xhr.send()

}
// ## MODAL prepare dcWrapper + open modal (on trigger click)
const prepareModalDcwrapper = (modal, dcId, dcUrl) => {
  const modalBody = modal.querySelector(".modal-body")
  modalBody.innerHTML = '<div id="dcWrapper' + dcId + '" class="dc-wrapper" data-dc-url="' + dcUrl + '"></div>';
  // open modal
  const bsModal = new Modal(modal)
  bsModal.show()

}
// ## MODAL show - handle dcloader
const handleModalHotpointShow = (modal) => {
  const dcWrapper = modal.querySelector("div[data-dc-url]")
  if (dcWrapper) {
    handleDcLoad(dcWrapper)
  }
}
// ## MODAL hidden - clear modal body
const handleModalHotpointHidden = (modal) => {
  const dcWrapper = modal.querySelector("div[data-dc-url")
  const modalBody = modal.querySelector(".modal-body")
  modalBody.innerHTML = ""
  if (dcWrapper) {
    viewRemove(dcWrapper.dataset.dcUrl, dcWrapper)
  }
}

/**
 * ######################
 * # XHR Event handlers #
 */
// # XHR Start
const onXhrLoadStart = (e) => {
  // dispatch event
  dcLoadStart({id: e.target.dcWrapper.id, xhr: e.target})
}
// # XHR Load
const onXhrLoad = (e) => {
  // 
}
// # XHR Complete
const onXhrLoadEnd = (e) => {
  const dcWrapper = e.target.dcWrapper
  if (!dcWrapper.classList.contains(CLASS_NAME_LOADING)) {
    trace("skip on DC handle request response, 'loading' class name missing", dcWrapper)
    return false
  }
  dcWrapper.innerHTML = e.target.responseText
  // dispatch event
  dcLoadComplete({id: dcWrapper.id})
  // dispatch router event
  viewAppend(dcWrapper.dataset.dcUrl, dcWrapper)
  // update vnmap scale
  updateVnmaps()
}
// # XHR Progress
const onXhrProgress = (e) => {
  // console.log("progress", e)
}
// # XHR Error
const onXhrError = (e) => {
  // dispatch event
  dcLoadError({id: e.target.dcWrapper.id, xhr: e.target})
}
// # XHR Abord
const onXhrAbord = (e) => {
  // dispatch abord
  dcLoadAbord({id: e.target.dcWrapper.id})
}
/**
 * ######################
 * # DOM Event Handlers #
 * 
 */
// Bootstrap offcanvas show
const onDocOffcanvasShow = (e) => {
  startContainerPlayback(e.target)
  const dcWrapper = e.target.querySelector("div[data-dc-url]")
  if (dcWrapper) {
    handleDcLoad(dcWrapper)
  }
}
// Bootstrap offcanvas hidden - cancel ajax loading if ongoing...
const onDocOffcanvasHide = (e) => {
  stopContainerPlayback(e.target)
}
// Bootstrap offcanvas hidden - cancel ajax loading if ongoing...
const onDocOffcanvasHidden = (e) => {
  const dcWrapper = e.target.querySelector("div[data-dc-url]")
  if (dcWrapper) {
    viewRemove(dcWrapper.dataset.dcUrl, dcWrapper)
    if (dcWrapper.classList.contains(CLASS_NAME_LOADING)) {
      dcCancel({id: dcWrapper.id})
    }
  }
}
// Bootsrap modal show
const onDocModalShow = (e) => {
  if (e.target.id == ID_MODAL_HOTPOINT) {
    handleModalHotpointShow(e.target)
  }
}
// Bootsrap modal hidden
const onDocModalHidden = (e) => {
  if (e.target.id == ID_MODAL_HOTPOINT) {
    handleModalHotpointHidden(e.target)
  }
}
const onDocClick = (e) => {
  // hotpoint modal trigger?
  if (e.target.dataset.tsawModal) {
    e.preventDefault()
    const targetSelector = e.target.getAttribute("href")
    const targetModal = targetSelector ? document.querySelector(targetSelector) : null
    const dcId = e.target.dataset.id
    const dcUrl = e.target.dataset.tsawModal
    // trace("modal trigger click", targetSelector, dcUrl)
    if (targetModal && dcId && dcUrl) {
      prepareModalDcwrapper(targetModal, dcId, dcUrl)
    }
  }
}
// Document mouseover - preload on hover
const onDocMouseover = (e) => {
  if (e.target?.dataset?.dcPreload) {
    const dcWrapper = document.querySelector(e.target.dataset.dcPreload)
    if (dcWrapper) {
      handleDcLoad(dcWrapper)
    }
  }
}
/**
 * ########################
 * # State event handlers #
 */
const onDcLoaderStatusChange = (dcLoader) => {
  const dcWrapper = document.getElementById(dcLoader.id)
  if (!dcWrapper) {
    dcLoader.xhr.abort()
    console.warn("dc loader status change but wrapper was not found", dcLoader)
    return
  }
  switch (dcLoader.status) {
    case AJAX_STATUS_LOADING:
      dcWrapper.classList.remove(CLASS_NAME_READY)
      dcWrapper.classList.add(CLASS_NAME_LOADING)
      break
    case AJAX_STATUS_ABORD:
      if (!dcWrapper.classList.contains(CLASS_NAME_READY)) {
        dcWrapper.classList.remove(CLASS_NAME_LOADING)
      }
      break
    case AJAX_STATUS_CANCEL:
      if (!dcWrapper.classList.contains(CLASS_NAME_READY)) {
        dcWrapper.classList.remove(CLASS_NAME_LOADING)
        dcLoader.xhr.abort()
      }
      break
    case AJAX_STATUS_COMPLETE:
      dcWrapper.classList.remove(CLASS_NAME_LOADING)
      dcWrapper.classList.add(CLASS_NAME_READY)
      break
  }
}
// Store change dcloader
const onStoreChangeDcLoader = (dcLoader, index) => {
  // get "old" dcloader from currentState
  const oldDcLoader = currentState?.reducerAjax?.dcLoaders.find(it => it.id == dcLoader.id)
  // did dcLoader change?
  if (!oldDcLoader || oldDcLoader.status != dcLoader.status) {
    // dcLoader status change - handle
    onDcLoaderStatusChange(dcLoader)
  } 
}
// on store change
const onStoreChange = () => {
  const state = store.getState()
  state.reducerAjax.dcLoaders.forEach(onStoreChangeDcLoader)
  currentState = state
}
